// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"288":"forgot-password","513":"create-password","535":"login","564":"reset-password","809":"account"}[chunkId] + ".css";
};